import React from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ReactSVG from 'react-svg';
import * as actionTypes from '~/store/actions/actionTypes';
import { filterOptions } from '~/store/reducers/historyFilterOptions';

import {
  IconOutgoingAnswered,
  IconIncoming,
  IconMissed,
  IconVoiceMail,
  IconOutgoingUnanswered,
  InternalCallNeutral,
  IconFastForward,
  IconAnnouncementsMegaphone,
  IconVideoAnswered,
  IconVideoMissed,
} from '~/assets/svgIcons';

import {
  FormControl,
  MenuProps,
  MenuItem,
  ListItemText,
  SVGContainer,
} from '../sharedStyles';

const CALL_DIRECTIONS = [
  // outgoing unanswered
  { name: 'Outgoing Answered', value: 'outgoing', icon: IconOutgoingAnswered },
  // outgoing answered
  {
    name: 'Outgoing Unanswered',
    value: 'unanswered',
    icon: IconOutgoingUnanswered,
  },
  // Incoming answered
  { name: 'Incoming Answered', value: 'incoming', icon: IconIncoming },
  // Incoming answered
  { name: 'Incoming Unanswered', value: 'missed', icon: IconMissed },
  // include_voicemail
  { name: 'Voicemail', value: 'include_voicemail', icon: IconVoiceMail },
  // Announcements = include_playback
  {
    name: 'Announcements',
    value: 'include_playback',
    icon: IconAnnouncementsMegaphone,
  },
  // include_internal
  { name: 'Internal', value: 'include_internal', icon: InternalCallNeutral },
  // group_transferred
  {
    name: 'Group Transferred',
    value: 'group_transferred',
    icon: IconFastForward,
  },
  {
    name: 'Internal Video Answered',
    value: 'video_answered',
    icon: IconVideoAnswered,
  },
  {
    name: 'Internal Video Unanswered',
    value: 'video_missed',
    icon: IconVideoMissed,
  },
];

export default function DirectionsSelector() {
  const selectorName = 'Call Directions';

  const dispatch = useDispatch();

  const [open, setOpen] = React.useState<boolean>(false);

  const selectedDirections = useSelector(
    (state: RootStateOrAny) => state.historyFilterOptions.directions
  );

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newDirections = event.target.value as string[];

    dispatch({
      type: actionTypes.SET_HISTORY_FILTER_OPTIONS,
      option: filterOptions.directions,
      payload: newDirections,
      extra: { resetCallItems: true },
    });
  };

  const handleToggle = (state: boolean) => {
    setOpen(state);
  };

  const handlePlaceholder = () => {
    const hasSelectedDirections = selectedDirections.length > 0;
    if (open || (hasSelectedDirections && !open)) {
      return selectedDirections;
    }
    return [selectorName];
  };

  const renderValue = (values: string[]) => {
    const [valueOne] = values;

    if (Array.isArray(values) && valueOne !== selectorName && CALL_DIRECTIONS) {
      const associatedIcons = values.map(directionValue => {
        const directionInfo = CALL_DIRECTIONS.find(
          item => item.value === directionValue
        );
        return directionInfo?.icon;
      });

      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {associatedIcons.slice(0, 3).map(icon => (
            <SVGContainer key={icon}>
              <ReactSVG
                // @ts-ignore
                src={icon}
                className="direction-icon"
                style={{ marginRight: 7, marginTop: 2 }}
              />
            </SVGContainer>
          ))}
        </div>
      );
    }

    return values;
  };

  return (
    <div>
      <FormControl
        variant="outlined"
        hasselecteditems={selectedDirections?.length}>
        <Select
          labelId="select-call-directions"
          id="select-call-directions"
          multiple
          disableUnderline
          input={<Input />}
          onOpen={() => handleToggle(true)}
          onClose={() => handleToggle(false)}
          onChange={handleChange}
          value={handlePlaceholder()}
          // @ts-ignore
          renderValue={renderValue}
          // @ts-ignore
          MenuProps={MenuProps}>
          <MenuItem firstItem value={selectorName} disabled>
            <ListItemText firstItem primary={selectorName} />
          </MenuItem>
          {CALL_DIRECTIONS.map(d => (
            <MenuItem key={d.value} value={d.value}>
              <Checkbox checked={selectedDirections.indexOf(d.value) > -1} />
              <ReactSVG src={d.icon} className="direction-icon" />
              <ListItemText primary={d.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
